import React, {ReactElement} from "react";
import {Link} from "@mui/material";
const MAILTO = '[[[mailto]]]'
const BOLD = '[[[bold]]]'

export function renderText(text: string, index: number = 0): ReactElement<any, any> {
    if (text[0] === '-') return <span key={index}><li>{text.substring(1)}</li></span>
    if (text.includes(BOLD)) return <span key={index}><strong>{text.replace(BOLD, '')}</strong><br/></span>
    if (text.includes(MAILTO)) {
        const textBeforeMail = text.substring(0, text.indexOf(MAILTO));
        let mailAddress = text.substring(text.indexOf(MAILTO)).replace(MAILTO, '');
        mailAddress = mailAddress.substring(0, mailAddress.indexOf(' '));
        const textAfterMail = text.replace(textBeforeMail, '').replace(mailAddress, '').replace(MAILTO, '');
        return <span key={index}>
            { textBeforeMail }
            <Link underline={'hover'} href={`mailto:${mailAddress}`}>{mailAddress}</Link>
            { textAfterMail }
        </span>
    }
    return <span key={index}>{text}<br /></span>
}